const servicePackage = [{
  desc: '分页查询商户服务包配置',
  options: {
    url: '/servicePackage/queryAuthorizedPackagePage',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/merchant'
  }
}, {
  desc: '分页查询商户服务包配置',
  options: {
    url: '/servicePackage/detail',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/ops'
  }
}, {
  desc: '服务项详情',
  options: {
    url: '/serviceItem/detail',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/ops'
  }
}, {
  desc: '分页查询权益下发记录',
  options: {
    url: '/servicePackage/queryIssueRecordPage',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/merchant'
  }
}, {
  desc: '查询权益下发明细',
  options: {
    url: '/servicePackage/queryIssueRecordDetail',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/merchant'
  }
}, {
  desc: '导出权益下发记录',
  options: {
    url: '/servicePackage/exportIssueRecord',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/merchant',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    }
  }
}, {
  desc: 'Excel批量导入车牌发放',
  options: {
    url: '/servicePackage/importIssueByExcel',
    method: 'post',
    baseURL: '/insapi/v3/equity/product/merchant',
    formdata: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
}]
export default servicePackage



// WEBPACK FOOTER //
// ./src/api/servicePackage.js